// extracted by mini-css-extract-plugin
module.exports = {"tab_main_title":"TabMainTitle_tab_main_title__1-MGx"};